/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostPressReleaseHistoryRequestBodyImages,
    PostPressReleaseHistoryRequestBodyImagesFromJSON,
    PostPressReleaseHistoryRequestBodyImagesFromJSONTyped,
    PostPressReleaseHistoryRequestBodyImagesToJSON,
} from './PostPressReleaseHistoryRequestBodyImages';

/**
 * プレスリリースの履歴を保存するAPIのリクエストボディ
 * @export
 * @interface PostPressReleaseHistoryRequestBody
 */
export interface PostPressReleaseHistoryRequestBody {
    /**
     * 企業Id
     * @type {number}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    companyId: number;
    /**
     * タイトル
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    title: string | null;
    /**
     * サブタイトル
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    subtitle: string | null;
    /**
     * 本文
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    text: string | null;
    /**
     * メイン画像のファイル名
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    imageFileNameMain: string | null;
    /**
     * メイン画像のS3ファイル名
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    imageFileNameMainS3: string | null;
    /**
     * 追加画像のリスト
     * @type {Array<PostPressReleaseHistoryRequestBodyImages>}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    images: Array<PostPressReleaseHistoryRequestBodyImages> | null;
    /**
     * ドキュメントファイル1のファイル名
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    referenceFileName: string | null;
    /**
     * ドキュメントファイル2のファイル名
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    releaseFileName: string | null;
    /**
     * メディア限定ドキュメント1のファイル名
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    mediaReleaseFileName: string | null;
    /**
     * メディア限定ドキュメント1のファイル名
     * @type {string}
     * @memberof PostPressReleaseHistoryRequestBody
     */
    mediaReferenceData: string | null;
}

export function PostPressReleaseHistoryRequestBodyFromJSON(json: any): PostPressReleaseHistoryRequestBody {
    return PostPressReleaseHistoryRequestBodyFromJSONTyped(json, false);
}

export function PostPressReleaseHistoryRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseHistoryRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'title': json['title'],
        'subtitle': json['subtitle'],
        'text': json['text'],
        'imageFileNameMain': json['image_file_name_main'],
        'imageFileNameMainS3': json['image_file_name_main_s3'],
        'images': (json['images'] === null ? null : (json['images'] as Array<any>).map(PostPressReleaseHistoryRequestBodyImagesFromJSON)),
        'referenceFileName': json['reference_file_name'],
        'releaseFileName': json['release_file_name'],
        'mediaReleaseFileName': json['media_release_file_name'],
        'mediaReferenceData': json['media_reference_data'],
    };
}

export function PostPressReleaseHistoryRequestBodyToJSON(value?: PostPressReleaseHistoryRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'title': value.title,
        'subtitle': value.subtitle,
        'text': value.text,
        'image_file_name_main': value.imageFileNameMain,
        'image_file_name_main_s3': value.imageFileNameMainS3,
        'images': (value.images === null ? null : (value.images as Array<any>).map(PostPressReleaseHistoryRequestBodyImagesToJSON)),
        'reference_file_name': value.referenceFileName,
        'release_file_name': value.releaseFileName,
        'media_release_file_name': value.mediaReleaseFileName,
        'media_reference_data': value.mediaReferenceData,
    };
}

